import { Box, Drawer, IconButton, Skeleton, Grid, Card } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

export default function AddIntegrationFormSkeleton() {
  const navigate = useNavigate();

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 500, md: 800 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header Skeleton */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0,
          backgroundColor: '#fff',
          position: 'sticky',
          top: 0,
          zIndex: 1
        }}
      >
        <Skeleton variant='text' width={180} height={32} />
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Scrollable Content Skeleton */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          p: 3
        }}
      >
        {/* Search Field Skeleton */}
        <Skeleton variant='rectangular' width='100%' height={56} sx={{ mb: 2, borderRadius: 1 }} />

        {/* Integration Grid Skeleton */}
        <Grid
          container
          spacing={2}
          sx={{
            height: 360,
            overflowY: 'auto',
            my: 0.5,
            pb: 1,
            pr: 2,
            alignContent: 'flex-start'
          }}
        >
          {[...Array(9)].map((_, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  border: '1px solid #eee',
                  borderRadius: 2,
                  p: 2.5
                }}
              >
                <Box display='flex' alignItems='center' gap={1.5}>
                  <Skeleton variant='rectangular' width={28} height={28} sx={{ borderRadius: 1 }} />
                  <Skeleton variant='text' width={120} height={20} />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Form Fields Skeleton */}
        <Box mt={3}>
          {/* Name Input Skeleton */}
          <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' width='100%' height={56} sx={{ mb: 3, borderRadius: 1 }} />

          {/* Location Select Skeleton */}
          <Skeleton variant='text' width={120} height={20} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' width='100%' height={56} sx={{ mb: 3, borderRadius: 1 }} />

          {/* OAuth Section Skeleton */}
          <Skeleton variant='text' width={200} height={24} sx={{ mb: 1 }} />
          <Skeleton variant='text' width={300} height={20} sx={{ mb: 2 }} />
          <Skeleton variant='rectangular' width={200} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      {/* Fixed Footer Skeleton */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderTop: '1px solid #DEDEDE',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          flexShrink: 0,
          backgroundColor: '#fff',
          position: 'sticky',
          bottom: 0
        }}
      >
        <Skeleton variant='rectangular' width={80} height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' width={80} height={40} sx={{ borderRadius: 1 }} />
      </Box>
    </Drawer>
  );
}
